export const LINE_BADGE_COLORS: Record<string, string> = {
  '1호선': '#0052A4',
  '2호선': '#57C429',
  '3호선': '#EF7C1C',
  '4호선': '#0072BC',
  '5호선': '#996CAC',
  '6호선': '#CD7C2F',
  '7호선': '#747F00',
  '8호선': '#E6186C',
  '9호선': '#BB8336',
};

export const ICON_CONVENIENCE_MAP: Record<string, string> = {
  // 한글 매핑
  무선인터넷: '/images/icons/icon_wifi.svg',
  남녀화장실: '/images/icons/icon_restroom.svg',
  주차가능: '/images/icons/icon_parking.svg',

  // 영어 매핑 (백엔드에서 영어로 올 수도 있음)
  wifi: '/images/icons/icon_wifi.svg',
  restroom: '/images/icons/icon_restroom.svg',
  parking: '/images/icons/icon_parking.svg',

  // 추가 가능한 편의시설들
  와이파이: '/images/icons/icon_wifi.svg',
  화장실: '/images/icons/icon_restroom.svg',
  주차: '/images/icons/icon_parking.svg',
  인터넷: '/images/icons/icon_wifi.svg',
};

// 편의시설 한글 번역 매핑
export const CONVENIENCE_KOREAN_MAP: Record<string, string> = {
  wifi: '무선인터넷',
  restrooms: '남녀화장실',
  parking: '주차가능',
};

export const Z_INDEX = {
  /** 기본 레이어 (페이지 구조) */
  Base: 0,

  /**서브헤더 */
  SubHeader: 98,

  /** 헤더 */
  Header: 99,

  /** 모바일 사이드바 */
  MobileSidebar: 100,

  /** 배경 요소 (백드롭 등) */
  Background: 201,

  /** 일반 콘텐츠 (카드, 섹션 등) */
  Content: 200,

  /** 드롭다운, 팝오버 */
  Dropdown: 300,

  /** 툴팁, 토스트 */
  Tooltip: 400,

  /** 모달, 다이얼로그 */
  Modal: 202,

  /** 풀스크린 오버레이 */
  Overlay: 600,

  /** 최상단(알림 배너, 글로벌 네비게이션) */
  TopMost: 900,

  /** 최상단(알림 배너, 글로벌 네비게이션) */
  Cta: 190,
} as const;
